import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TagsFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";

export abstract class AAtmosphere extends ABusiness {
    readonly icon = () => h(TagsFilled, {style: 'color:#22c55e'});
    readonly title = '基础';
    readonly description = '';
    readonly implementations = [];

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }
}